// import React from "react";
// import { Box } from "@mui/material";
// import {
//   ConfirmationNumberOutlined,
//   TimelapseOutlined,
//   CheckCircleOutlineRounded,
// } from "@mui/icons-material";
// import AppStatTile from "../../../components/AppStatTile";
// import {
//   primaryColor,
//   accentColor,
//   successColor,
//   MESSAGES,
// } from "../../../constants/consts";

// export default function SupportSummary({ total, active, completed }) {
//   const items = [
//     {
//       icon: ConfirmationNumberOutlined,
//       label: MESSAGES.SUPPORT_STAT_TOTAL,
//       value: total,
//       color: primaryColor,
//     },
//     {
//       icon: TimelapseOutlined,
//       label: MESSAGES.SUPPORT_STAT_ACTIVE,
//       value: active,
//       color: accentColor,
//     },
//     {
//       icon: CheckCircleOutlineRounded,
//       label: MESSAGES.SUPPORT_STAT_DONE,
//       value: completed,
//       color: successColor,
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         display: "grid",
//         gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
//         gap: 2,
//       }}
//     >
//       {items.map((item, i) => (
//         <AppStatTile
//           key={i}
//           icon={item.icon}
//           label={item.label}
//           value={String(item.value)}
//           color={item.color}
//         />
//       ))}
//     </Box>
//   );
// }
import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import {
  ConfirmationNumberOutlined,
  TimelapseOutlined,
  CheckCircleOutlineRounded,
} from "@mui/icons-material";
import AppStatTile from "../../../components/AppStatTile";
import {
  primaryColor,
  accentColor,
  successColor,
  MESSAGES,
} from "../../../constants/consts";

// --- Animasyon ---
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(18px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/**
 * 0'dan hedefe yumuşak sayaç.
 * - easeOutCubic ile yavaşlayarak durur
 * - duration içinde biterse setState durur
 * - hedef değişirse baştan sayar
 */
function useCountUp(target, { duration = 200, delay = 0 } = {}) {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);
  const startTimeRef = useRef(0);

  useEffect(() => {
    const goal = Number(target) || 0;

    // Başlangıç değeri (kaldığı yerden devam etsin)
    const from = 0;
    cancelAnimationFrame(rafRef.current);

    const tick = (now) => {
      if (!startTimeRef.current) startTimeRef.current = now;
      const elapsed = now - startTimeRef.current - delay;

      if (elapsed < 0) {
        rafRef.current = requestAnimationFrame(tick);
        return;
      }

      const t = Math.min(elapsed / duration, 1);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = Math.round(from + (goal - from) * eased);
      setValue(current);

      if (t < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setValue(goal);
      }
    };

    startTimeRef.current = 0;
    rafRef.current = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(rafRef.current);
  }, [target, duration, delay]);

  return value;
}

// Küçük tile wrapper'ı: her tile kendi değerini saysın
function CountingTile({ icon, label, value, color, index }) {
  const counted = useCountUp(value, {
    duration: 900,
    delay: 120 + index * 80, // tile animasyonuyla uyumlu gecikme
  });

  return (
    <Box
      sx={{
        animation: `${fadeInUp} 0.45s cubic-bezier(0.22, 1, 0.36, 1) ${
          index * 0.08
        }s backwards`,
        transition: "transform 0.25s ease",
        "&:hover": { transform: "translateY(-2px)" },
      }}
    >
      <AppStatTile
        icon={icon}
        label={label}
        value={String(counted)}
        color={color}
      />
    </Box>
  );
}

export default function SupportSummary({ total, active, completed }) {
  const items = [
    {
      icon: ConfirmationNumberOutlined,
      label: MESSAGES.SUPPORT_STAT_TOTAL,
      value: total,
      color: primaryColor,
    },
    {
      icon: TimelapseOutlined,
      label: MESSAGES.SUPPORT_STAT_ACTIVE,
      value: active,
      color: accentColor,
    },
    {
      icon: CheckCircleOutlineRounded,
      label: MESSAGES.SUPPORT_STAT_DONE,
      value: completed,
      color: successColor,
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
        gap: 2,
      }}
    >
      {items.map((item, i) => (
        <CountingTile
          key={i}
          index={i}
          icon={item.icon}
          label={item.label}
          value={Number(item.value) || 0}
          color={item.color}
        />
      ))}
    </Box>
  );
}
